import type { KeyboardEvent } from "react";

const ACTIVATION_KEYS = new Set(["Enter", " "]);

/**
 * Enter / Space on a focused clickable row or card opens it. Keys pressed on a
 * nested control (checkbox, favorite) belong to that control, so they are ignored.
 */
export function handleRowActivationKey(event: KeyboardEvent<HTMLElement>, onActivate: () => void): void {
  if (event.target !== event.currentTarget) return;
  if (!ACTIVATION_KEYS.has(event.key)) return;
  event.preventDefault();
  onActivate();
}
